import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/ProformaInvoice/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__heading-container')}>
          <h1 className={cn('header__heading')}>
            <span>Proforma Invoice</span>{' '}
            <span>Forms and Templates</span>
          </h1>
          <p className={cn('header__heading-description')}>
            Before the deal is signed or the container is booked, you have the Proforma Invoice. It’s
            essentially a "pre-invoice" or a formal quotation. For forwarders and exporters, the Proforma is
            a crucial tool for getting the ball rolling. It helps the buyer get internal approvals, secure
            financing (like a Letter of Credit), or apply for import licenses before the goods even leave the
            factory floor.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;